import { render, staticRenderFns } from "./SidebarRoutes.vue?vue&type=template&id=7c603bc5&scoped=true&"
import script from "./SidebarRoutes.vue?vue&type=script&lang=js&"
export * from "./SidebarRoutes.vue?vue&type=script&lang=js&"
import style0 from "./SidebarRoutes.vue?vue&type=style&index=0&id=7c603bc5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c603bc5",
  null
  
)

export default component.exports